import React, { useContext } from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import { StepContext } from './Step';

import Styled from './styles';

export interface SubStepIndicatorProps {
  /* If true, the step is disabled. Sub step is also disabled if the parent Step is disabled. */
  disabled?: boolean;
  /** The variant for styling purposes.  */
  variant?: 'current' | 'future' | 'error' | 'warning' | 'completed';
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any
}
/** `SubStepIndicator`, all other props will be provided to the root component. The variant and disabled state is taken from the parent Step context. */
const SubStepIndicator = React.forwardRef<HTMLElement, SubStepIndicatorProps>((props, ref) => getContext(({ theme, RTL }) => {
  const { theme: themeProp, disabled, variant, ...otherProps } = props;
  const stepContext = useContext(StepContext);
  const resolvedTheme = _merge({}, theme.STEP_FORM, themeProp.STEP_FORM || themeProp);
  return (
    <Styled.SubStepIndicator
      ref={ref}
      rtl={RTL}
      $theme={resolvedTheme}
      $variant={variant || stepContext.variant}
      disabled={disabled || stepContext.disabled}
      {...otherProps}
    />
  );
}));

SubStepIndicator.defaultProps = {
  disabled: false,
  variant: 'future',
  theme: {},
};

SubStepIndicator.displayName = 'SubStepIndicator';

export default SubStepIndicator;